/** @module Apparel/EditColorMaterial **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/EditController",
	"csi/def/Request",
	"csi/xml"
], function(declare,lang,EditController,Request,xml) {

	var PROPAGATE = "Propagate3DMaterial";
	var PROPAGATE_FIELD = "3DPropagate3DMaterials";
	var COLOR_SPECIFICATION = "ColorSpecification";

	return declare(EditController, {
		/*
		 * @override
		 * Return to appropriate server operation
		 */
		_getActionRequest: function () {
			return lang.mixin(new Request(), {
				m_module: "Apparel",
				m_operation: "EditColorMaterial"
			});
		},

		/**
		 * Call server Java operation to edit Color Material and propagate 3D Material if needed
		 */
		toWriterRequest: function() {
			var formData = this.getFormData();

			// Edit Color Material using server operation
			return this.inherited(arguments)
				.addParameter(PROPAGATE, xml.ATTR_BOOLEAN, formData.getFieldValue(PROPAGATE_FIELD, true))
				.addParameter(COLOR_SPECIFICATION, xml.ATTR_REF, formData.getFieldValue(COLOR_SPECIFICATION, true));
		}
	});
});
